var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { makeAutoObservable } from "mobx";
import { Money } from "../../core";
import { perRestaurant } from "../../di";
import { ServiceFeeSettingsService } from "../ServiceFeeSettingsService";
let ServiceFeePriceService = class ServiceFeePriceService {
    constructor(serviceFeeSettingsService) {
        this.serviceFeeSettingsService = serviceFeeSettingsService;
        makeAutoObservable(this);
    }
    get percentage() {
        return this.serviceFeeSettingsService.percentage;
    }
    getValue(base) {
        if (this.percentage === null) {
            return Money.zero();
        }
        if (base.leq(Money.zero())) {
            return Money.zero();
        }
        const raw = base.percentage(this.percentage);
        const bounds = this.serviceFeeSettingsService.bounds;
        if (bounds === null) {
            return raw;
        }
        return raw.max(bounds.min).min(bounds.max);
    }
};
ServiceFeePriceService = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [typeof (_a = typeof ServiceFeeSettingsService !== "undefined" && ServiceFeeSettingsService) === "function" ? _a : Object])
], ServiceFeePriceService);
export { ServiceFeePriceService };
